/* eslint-disable linebreak-style */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useFetchPosProfileDetails } from '../user';
import { addBulkItemsToCart } from '@/store/slices/cart';
import {
  selectAuth,
  selectCart,
  selectOrder,
  selectPrinter,
} from '@/store/selectors';
import {
  updateInvoice,
  addCustomer,
  updateTax,
  updateDiscount,
  updateSubTotal,
  updateTotal,
} from '@/store/slices/order';
import { setAlert } from '@/store/slices/alert';
import { NewKOTType, UpdateKOTType } from '@/types/utils';
import { openModal } from '@/store/slices/modal';
// import { printKOT } from '@/utils/printer';
// eslint-disable-next-line @typescript-eslint/no-explicit-any

let END_POINT: string;
const updateEndpoint =
  '/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.update_invoice';

const fetcher = (url: any, KOTData: NewKOTType | UpdateKOTType) => {
  const response = axios({
    method: 'post',
    url: `https://${url}${END_POINT}`,
    data: { data: { ...KOTData } },
    withCredentials: true,
  })
    .then((data) => data)
    .catch((error) => error);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useUpdateInvoice = () => {
  const { url, fullName } = useSelector(selectAuth);
  const { default: defaultPrinter } = useSelector(selectPrinter);
  const { data: posProfile } = useFetchPosProfileDetails();
  const { items, subtotal } = useSelector(selectCart);
  const { restaurant_table, customer, current_invoice, discount } =
    useSelector(selectOrder);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  // If a current invoice exists, create an update KOTData,
  // and update the endpoint to use the update invoice

  const KOTData: UpdateKOTType = {
    name: current_invoice,
    discount_amount: discount,
    customer,
    items,
  };
  END_POINT = updateEndpoint;

  const handleSuccess = (data: any) => {
    dispatch(updateSubTotal(data.total));
    dispatch(updateTotal(data.grand_total));
    dispatch(updateInvoice(data.name));
    dispatch(addCustomer(data.customer));
    dispatch(updateTax(data.total_taxes_and_charges));
    dispatch(updateDiscount(data.discount_amount));

    dispatch(openModal({ type: 'submitPayment' }));
  };

  const handleError = () => {
    dispatch(
      setAlert({ type: 'error', message: 'An Error Occured. Try again later' }),
    );
  };

  const mutate = useMutation(() => fetcher(url, KOTData), {
    onSettled: (data) => {
      if (!data.data) {
        handleError();
      } else if (data.data) {
        const tableItems = data.data.message?.kots[0].items;

        handleSuccess(data.data?.message?.invoice);

        const invoice = data.data.message?.invoice.name;
        queryClient.invalidateQueries(['KOT', 'invoices']);

        const printerObj = {
          port: defaultPrinter.port,
          ipAddress: defaultPrinter.ipAddress,
          invoice,
          customer,
          waiter: fullName,
          table: restaurant_table,
          area: 'null',
          items: tableItems,
        };
        // printKOT(printerObj);
      }
    },
  });

  return mutate;
};
